<template>
  <layout-fullpage>
    <page-headline tag="h1" :title="`收據查詢 - ${resQueryData.householdName}`" />
    <loading :show="apiLoading" />
    <b-form class="radioTypeBox">
      <div class="form-row dateBox radio-row">
        <!-- 收據號碼 -->
        <input-text
          :val="searchForm.rpPublicNo"
          :labelName="'收據號碼'"
          :colClassName="'col-12 col-md-4 mr-2 rpPublicNo'"
          @inputVal="inputVal"
        ></input-text>

        <!-- 收據日期 -->
        <input-radio
          :labelName="'收據日期'"
          :radioData="radioData"
          @getDate="getDate"
        ></input-radio>

        <div class="col-auto searchBtn-circle mb-2">
          <b-button variant="action" class="rounded-circle" @click="search()">
            <i class="fa fa-search"></i>
          </b-button>
        </div>
      </div>
    </b-form>

    <!-- 手機版 -->
    <div class="d-lg-none">
      <b-card
        no-body
        class="mb-3"
        v-for="(item, index) in tabledatas"
        :key="`RESULT_LIST_MOBILE__${index}`"
      >
        <!-- <b-card-header header-bg-variant="primary" header-text-variant="white">
          序號：{{ index + 1 }}
        </b-card-header> -->
        <b-table-simple borderless striped class="mb-0">
          <colgroup>
            <col width="160" />
            <col />
          </colgroup>
          <b-tbody>
            <!-- <b-tr v-for="(subItem, index) in tableTh" :key="index">
              <b-th>{{ subItem.item }}</b-th>
              <b-td>{{ item.rpPublicNo }}</b-td>
            </b-tr> -->
            <b-tr>
              <b-th>收據號碼</b-th>
              <b-td>{{ item.rpPublicNo }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>收據日期</b-th>
              <b-td>{{ item.rpDate | TWDateFormat('tYY/MM/DD') }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>繳款機關 / 繳款人</b-th>
              <b-td>{{ item.rpPayManName }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>繳款項目</b-th>
              <b-td>{{ item.piName }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>金額</b-th>
              <b-td>{{ item.rpArAmt | currencyFormat }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>開立機關</b-th>
              <b-td>{{ item.ogName }}</b-td>
            </b-tr>
            <b-tr>
              <b-th>已作廢</b-th>
              <b-td>{{ item.rpStatus === '9' ? '已作廢' : '' }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-card-footer>
          <b-row>
            <b-col>
              <b-button variant="action" block class="m-1" @click="showDetails(item, index)"
                >明細</b-button
              >
            </b-col>
            <b-col v-if="item.rpStatus !== '9'">
              <b-button variant="action" block class="m-1" @click="previewReceipt(item, index)"
                >預覽</b-button
              >
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </div>

    <!-- 電腦版 -->
    <div class="d-none d-lg-block">
      <b-table-simple id="itemList" caption-top responsive striped table-class="table-rounded">
        <caption class="sr-only">
          收據查詢結果
        </caption>

        <!-- 表格title -->
        <b-thead head-variant="primary">
          <b-tr>
            <b-th v-for="(subItem, index) in tableTh" :key="index" :class="subItem.class">{{
              subItem.title
            }}</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(item, index) in tabledatas" :key="`RESULT_LIST__${index}`">
            <!-- <b-th class="text-center">{{ index + 1 }}</b-th> -->
            <b-td>{{ item.rpPublicNo }}</b-td>
            <b-td class="text-center">{{ item.rpDate | TWDateFormat('tYY/MM/DD') }}</b-td>
            <b-td>{{ item.rpPayManName }}</b-td>
            <b-td>{{ item.piName }}</b-td>
            <b-td style="text-align: right">{{ item.rpRealAmt | currencyFormat }}</b-td>
            <b-td>{{ item.ogName }}</b-td>
            <b-td>{{ item.rpStatus === '9' ? '已作廢' : '' }}</b-td>
            <b-td class="text-nowrap" style="text-align: center">
              <b-button variant="action" size="sm" class="m-1" @click="showDetails(item)"
                >明細</b-button
              >
              <b-button
                v-if="item.rpStatus !== '9'"
                variant="action"
                size="sm"
                class="m-1"
                @click="previewReceipt(item)"
                >預覽</b-button
              >
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>

    <div>
      <span class="totalListLength"> 總筆數:{{ tableData.length }} </span>
      <!-- 分頁元件 -->
      <b-pagination
        align="center"
        pills
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="itemList"
        class="justify-content-center"
      ></b-pagination>
    </div>
    <div class="row align-items-center text-center mb-4 small">
      <div class="col-12 col-md mb-2 mb-md-0">
        <go-home-btn
          :btnSize="'sm'"
          :btnClass="'btn-miw mx-1 mb-2'"
          :btnVariant="'primary'"
          :btnName="'回查詢戶政收據首頁'"
          :isHousehold="true"
          :householdUUId="householdUUId"
          :resQueryCacheData="resQueryCacheData"
        >
          <template slot="goHomeBtn"></template>
        </go-home-btn>
      </div>
    </div>

    <!-- 收據明細 -->
    <detail-modal ref="detailData"></detail-modal>
    <!-- 收據預覽 -->
    <receipt-preview
      :btnName="'回查詢戶政收據首頁'"
      :isHousehold="true"
      :resQueryCacheData="resQueryCacheData"
      ref="receiptPreview"
    ></receipt-preview>
  </layout-fullpage>
</template>

<script>
// 引入 json
import { tableTh } from '@/configs/tableTh';

import { mapMutations } from 'vuex';

import LayoutFullpage from '@/layouts/Fullpage.vue';
import Loading from '@/components/Loading.vue';

// 共用 utils
import ApiMixin from '@/mixins/api';
import CommonApiMixin from '@/mixins/commonApi';
import UserMixin from '@/mixins/user';
import MakePdf from '@/mixins/makePdf';

// const tw = require('moment-taiwan');

export default {
  name: 'PageHouseholdInquiryInside',

  components: {
    LayoutFullpage,
    Loading,
  },

  mixins: [ApiMixin, CommonApiMixin, UserMixin, MakePdf],

  data() {
    return {
      currentPage: 1,
      perPage: 6, // 分頁

      pagination: {
        prePage: 1,
      },

      searchCollapse: false,

      organList: [], // 機關選單
      payItemList: [], // 繳款選單
      payItemListNew: [], // 繳款選單 關聯完
      ispayItemListNew: false, // 繳款選單 開關

      searchForm: {
        rpPublicNo: '',
        oid: '',
        creator: null,
        paymentItem: null,
        createStart: null,
        createEnd: null,
        receiptStart: this.$moment().local().subtract(1, 'years').format('yyyy-MM-DD 00:00:00.000'),
        receiptEnd: this.$moment().local().format('yyyy-MM-DD 23:59:59.000'),
      },

      tableData: [],
      // 表格title Data
      tableTh,
      detailData: [],
      rpPublicNo: null,
      rpPublicRandomCode: null,
      rpId: null,
      rpDownloadCount: null,
      response: {}, // API成功
      error: {}, // API失敗
      sessionId: '', // 放cookie的sessionId
      sessionSource: '',

      apiLoading: false,

      ogId: null, // 機關id
      ogInputVal: null, // 機關input Val
      piId: null, // 繳款項目 id
      piInputVal: null,

      // 單選資料
      radioData: [
        {
          csiName: '最近1個月',
          csiValue: 'month',
        },
        {
          csiName: '最近3個月',
          csiValue: 'season',
        },
        {
          csiName: '最近6個月',
          csiValue: 'halfYear',
        },
        {
          csiName: '最近1年',
          csiValue: 'year',
        },
      ],
      resQueryData: {}, // 查詢收據資料
      resQueryCacheData: {}, // UUID 查詢 的cache資料
      householdUUId: null, // 戶役政 ssesionId
    };
  },
  created() {
    this.householdUUId = this.$getUUID('householdUUId');
    console.log('householdUUId-', this.householdUUId);
    if (
      this.householdUUId === '' ||
      this.householdUUId === null ||
      this.householdUUId === undefined
    ) {
      console.log('回到查詢頁');
      this.$router.push({
        name: 'householdInquiry',
      });
    } else {
      console.log('有cookie');
      this.queryCacheManager(this.householdUUId);
    }
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    tabledatas() {
      return this.tableData.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  },

  methods: {
    // 取Select資料
    async getSelectItme() {
      try {
        const data = {
          // rpPayManId,
        };
        const url = '/GovEReceipt/FrontDeskService/QuerySelectBox';
        const method = 'post';
        this.axiosServiceSend(data, url, method, 'receiptQuerySelectBox');
      } catch (error) {
        console.error(error);
      }
    },
    // 使用共用API結果
    success(type, res, otherObj) {
      console.log(otherObj);
      const resObj = res.data.object;
      switch (type) {
        case 'receiptQuerySelectBox': // 下拉選單
          this.organList = resObj.organList;
          this.payItemList = resObj.payItemList;
          break;
        case 'Query':
          this.response = res;
          this.tableData = resObj;
          this.apiLoading = false;
          this.analysis();
          break;
        case 'queryCache':
          this.resQueryCacheData = resObj;
          this.isUUIDTime(resObj.sessionExpireDate, resObj.sessionId, resObj);
          break;
        case 'deleteCache':
          if (resObj === true) {
            this.$clearCookie('householdUUId', this.householdUUId);
            this.$router.push({
              name: 'householdInquiry',
            });
          }
          break;
        case 'Analysis':
          console.log('Analysis', res);
          break;
        default:
          break;
      }
    },
    fail(type, error, other) {
      console.log('fail', type, error, other);
      switch (type) {
        case 'Analysis':
          console.log('Analysis', error);
          break;
        default:
          break;
      }
      this.apiLoading = false;
    },
    ...mapMutations('login', ['changeLogin']),

    showDetails(rowData, index) {
      this.$refs.detailData.getDetailData(rowData, index);
    },

    // 基礎查詢
    search() {
      const { rpPublicNo } = this.searchForm;
      const data = {
        rpPublicNo,
        rpOgId: this.resQueryData.rpOgId,
        rpPayManId: this.resQueryData.rpPayManId,
        sessionSource: 'H',
      };
      this.getData(data);
    },

    async getData(data) {
      this.apiLoading = true;
      const changeData = data;
      changeData.rpDateStart = this.searchForm.receiptStart;
      changeData.rpDateEnd = this.searchForm.receiptEnd;
      await this.axiosServiceSend(
        data,
        '/GovEReceipt/FrontDeskService/QueryFNTSFHouse',
        'post',
        'Query'
      );
    },

    // 瀏覽
    previewReceipt(rowData) {
      const pdfnym = rowData.pdfNym;
      const data = {
        rpPublicNo: rowData.rpPublicNo,
        rpPublicRandomCode: rowData.rpPublicRandomCode,
      };
      const url = {
        preview: `/GovEReceipt/PdfService/previewPdf${pdfnym === null ? '' : `/${pdfnym}`}`,
        downloadPdf: `/GovEReceipt/PdfService/downloadPdf${pdfnym === null ? '' : `/${pdfnym}`}`,
      };
      this.$refs.receiptPreview.showModal(data, url);
    },
    // 取得收據號碼
    inputVal(val) {
      this.searchForm.rpPublicNo = val;
    },
    // 取得收據日期
    getDate(start, end) {
      this.searchForm.receiptStart = start;
      this.searchForm.receiptEnd = end;
    },

    // 查詢 有無戶役政資料 (UUID)
    async queryCacheManager(sessionId) {
      console.log('打API檢查是否有此資料', sessionId);
      // this.apiLoading = true;
      try {
        const data = {
          sessionId,
          sessionSource: 'H',
        };
        const url = '/GovEReceipt/CacheManagerService/Query';
        const method = 'post';
        this.axiosServiceSend(data, url, method, 'queryCache');
      } catch (error) {
        this.apiLoading = false;
        console.error(error);
      }
    },

    // 判斷刪除 戶役政 暫存資料 時間
    isUUIDTime(expire, UUID, data) {
      const deleteExpires = new Date(expire).getTime() - 300000;
      const todayTime = new Date().getTime();
      if (todayTime > deleteExpires) {
        this.$deleteCache(data);
      } else {
        this.resQueryData = JSON.parse(data.dataMessage);
        this.getData(this.resQueryData);
        this.ogId = this.resQueryData.rpOgId;
        console.log('resQueryData', this.resQueryData);
      }
    },
    // 流量分析
    analysis() {
      const data = {
        faSource: 'HouseholdInquiry',
        faOgId: this.resQueryData.rpOgId,
      };
      this.axiosServiceSend(data, '/GovEReceipt/Analysis/AnchorPointAnalysis', 'post', 'Analysis');
    },
  },
};
</script>
